/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import msglogo from '../../assets/Messages.svg';
import logoImg from '../../assets/logo.png';
import CompanyEmailValidator from 'company-email-validator';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import TermsofUseDialog from './TermsofUseDialog';

import { encryptObject } from '../api/Auth';
import { useNavigate } from 'react-router-dom';
import { environment } from '../../environments/environment';
import { analytics } from './LoginAccount';
import { dsVar } from '../theme/tokens';

const CreateAccount = () => {
  const [signupFlag, setsignupFlag] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [termsofUse, setTermsofUse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [snackbarMessage, setSnackbarMessage] = useState('');
  var navigate = useNavigate();
  const [snackbarSeverity, setSnackbarSeverity] = useState('error'); // Initial severity

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };

  useEffect(() => {}, [loading]);
  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const handleChangeConfirmPassword = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      handleOpenSnackbar('Email cannot be empty','error');
      return;
    }

    // Validation: Check if email format is valid
    else if (!emailRegex.test(email)) {
      handleOpenSnackbar('Invalid email format','error');
      return;
    } else if (!password || !confirmPassword) {
      handleOpenSnackbar('Password cannot be empty','error');
      return;
    } else if (password !== confirmPassword) {
      handleOpenSnackbar('Passwords do not match!','error');
      return;
    } else if (!checkbox1 || !checkbox2) {
      handleOpenSnackbar('Agree to terms and conditions to proceed','error');
      return;
    }
    else if (!CompanyEmailValidator.isCompanyEmail(email)) {
      handleOpenSnackbar('Please sign up using your business email', 'error');
      return;
    }
     else {
      getRegistration();
    }
  };

  const handleClick1 = () => {
    navigate('/login');
  };

  const handleChange = (event) => {};
  const handleBackClick = () => {
    setCheckbox1(false);
    setCheckbox2(false);
    setsignupFlag(!signupFlag);
  };

  useEffect(() => {}, [signupFlag]);

  const getRegistration = async () => {
    setLoading(true);
    try {
      let data = { admin_email: email, password: password };

      let encryptedData = encryptObject(data);

      const payload = encryptedData;
      const res = await axios.post(
        `${environment.apiUrl}/auth/initiateSignup`,
        payload
      );
      handleOpenSnackbar(res?.data?.data,'success');
      analytics.track('New_registrations');
      setsignupFlag(true);
      setLoading(false);
    } catch (error) {

      handleOpenSnackbar(error?.response?.data?.errMessage,'error');

      console.log('error', error);
      setLoading(false);
 
    }
  };

  return (
    <div className="flex min-h-[100vh] w-full flex-col lg:flex-row overflow-hidden bg-page font-sans text-fg m-0 p-0 text-left">
      {/* Left Column (hidden on mobile) */}
      <div className="hidden lg:flex flex-1 flex-col justify-between p-12 relative overflow-hidden border-r border-fg-2/20 bg-page">
        <div className="flex items-center gap-1 z-20">
          <img src={logoImg} alt="Data[S]cient.ai" className="h-8" />
        </div>
        <div className="flex flex-col items-start gap-12 z-10 flex-grow justify-center mt-12">
          <div className="space-y-4 max-w-lg text-left">
            <h1 className="text-5xl font-extrabold leading-tight text-fg tracking-tight font-mono text-left m-0">
              Your <span className="text-accent-fg">data</span>, finally making sense.
            </h1>
            <p className="text-lg text-fg-2 font-normal m-0 text-left">
              From complex patterns to clear priorities in a single click.
            </p>
          </div>
          <div className="w-full max-w-2xl relative">
            <div className="absolute -top-20 -left-20 w-80 h-80 bg-accent/5 rounded-full blur-3xl"></div>
            <div className="relative bg-surface rounded-xl shadow-2xl overflow-hidden border border-fg/10 flex flex-col md:flex-row h-auto min-h-[350px]">
              <div className="w-full md:w-64 border-b md:border-b-0 md:border-r border-fg/5 bg-page/50 flex flex-col p-4 gap-4 flex-shrink-0">
                <div className="flex items-center gap-1 mb-2">
                  <img src={logoImg} alt="Data[S]cient.ai" className="h-5" />
                </div>
                <div className="space-y-3">
                  <div className="bg-fg/5 p-3 rounded border border-fg/10 text-left">
                    <p className="text-[10px] text-fg-2 m-0">"Show me the conversion trends for Q3 compared to last year."</p>
                  </div>
                  <div className="bg-accent/5 p-3 rounded border border-accent-fg/20 text-left">
                    <p className="text-[10px] text-accent-fg font-medium italic m-0">Analyzing your dataset...</p>
                    <div className="mt-2 flex gap-1">
                      <div className="w-1 h-1 bg-accent rounded-full"></div>
                      <div className="w-1 h-1 bg-accent rounded-full"></div>
                      <div className="w-1 h-1 bg-accent rounded-full"></div>
                    </div>
                  </div>
                </div>
                <div className="mt-auto relative pt-4 md:pt-0">
                  <div className="w-full h-8 bg-fg/5 rounded border border-fg/10 flex items-center px-2">
                    <div className="w-full h-1 bg-fg/10 rounded"></div>
                    <span className="material-symbols-outlined text-xs text-fg-2 ml-auto">send</span>
                  </div>
                </div>
              </div>
              <div className="flex-1 p-6 flex flex-col overflow-hidden min-w-0">
                <div className="flex justify-between items-center mb-6 flex-shrink-0">
                  <div className="space-y-1">
                    <div className="h-4 w-32 bg-fg/10 rounded"></div>
                    <div className="h-2 w-20 bg-fg/5 rounded"></div>
                  </div>
                  <div className="flex gap-2">
                    <div className="h-8 w-8 rounded bg-fg/5 border border-fg/10"></div>
                    <div className="h-8 w-8 rounded bg-fg/5 border border-fg/10"></div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mb-6 flex-shrink-0">
                  <div className="bg-fg/5 p-4 rounded border border-fg/10 flex flex-col justify-between">
                    <div className="flex justify-between mb-4">
                      <div className="w-2 h-2 rounded-full bg-accent"></div>
                      <div className="w-10 h-1 bg-fg/10 rounded"></div>
                    </div>
                    <div className="flex items-end gap-1 h-16 w-full">
                      <div className="flex-1 bg-fg/10 rounded-t h-[40%]"></div>
                      <div className="flex-1 bg-fg/20 rounded-t h-[60%]"></div>
                      <div className="flex-1 bg-accent/40 rounded-t h-[80%]"></div>
                      <div className="flex-1 bg-accent rounded-t h-[100%]"></div>
                      <div className="flex-1 bg-accent/60 rounded-t h-[70%]"></div>
                    </div>
                  </div>
                  <div className="bg-fg/5 p-4 rounded border border-fg/10 flex flex-col justify-between">
                    <div className="flex justify-between mb-4">
                      <div className="w-2 h-2 rounded-full bg-white"></div>
                      <div className="w-10 h-1 bg-fg/10 rounded"></div>
                    </div>
                    <div className="flex items-center justify-center h-16 w-full relative">
                      <div className="relative w-10 h-10 rounded-full border-2 border-fg/10 border-t-accent-fg border-r-accent-fg shrink-0"></div>
                    </div>
                  </div>
                </div>
                <div className="bg-fg/5 p-4 rounded border border-fg/10 h-28 relative overflow-hidden flex-shrink-0 w-full">
                  <svg className="absolute bottom-0 left-0 w-full h-[50px]" preserveAspectRatio="none" viewBox="0 0 400 50">
                    <path d="M0 50 V30 Q50 5 100 25 T200 10 T300 35 T400 15 V50 Z" fill="url(#darkGrad)" fillOpacity="0.2"></path>
                    <path d="M0 30 Q50 5 100 25 T200 10 T300 35 T400 15" fill="none" stroke="#FFDE59" strokeWidth="2"></path>
                    <defs>
                      <linearGradient id="darkGrad" x1="0%" x2="0%" y1="0%" y2="100%">
                        <stop offset="0%" style={{ stopColor: '#FFDE59', stopOpacity: 1 }}></stop>
                        <stop offset="100%" style={{ stopColor: '#FFDE59', stopOpacity: 0 }}></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="text-sm text-fg-2 z-10 font-mono uppercase tracking-widest text-left mt-8 m-0">
          © 2024 Data[S]cient.ai
        </p>
      </div>

      {/* Right Column (Signup Form) */}
      <div className="flex-1 flex flex-col justify-center items-center p-6 md:p-12 lg:p-24 relative bg-page">
        <div className="lg:hidden flex items-center gap-1 mb-12 self-start md:self-center">
          <img src={logoImg} alt="Data[S]cient.ai" className="h-8" />
        </div>

        {signupFlag === false ? (
          <div className="w-full max-w-[440px] flex flex-col z-10 mx-auto text-left">
            <div className="mb-10 text-center lg:text-left">
              <h1 className="text-3xl font-extrabold text-fg mb-2 font-mono tracking-tight m-0">Create an Account</h1>
              <p className="text-fg-2 text-lg mt-2 m-0">Free 14-day, no commitment trial. No credit card required.</p>
            </div>

            <form className="space-y-6 w-full m-0" onSubmit={handleSubmit}>
              <div className="flex flex-col gap-2">
                <label className="text-xs font-bold text-fg uppercase tracking-wider m-0" htmlFor="work-email">Email</label>
                <input
                  className="flex w-full rounded-lg text-fg bg-fg/5 border border-fg/10 focus:ring-1 focus:ring-accent-fg focus:border-accent-fg focus:outline-none h-14 placeholder:text-fg-2/50 p-4 text-base font-normal transition-all m-0 box-border"
                  id="work-email"
                  placeholder="name@company.com"
                  required
                  type="email"
                  value={email}
                  onChange={handleChangeEmail}
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-xs font-bold text-fg uppercase tracking-wider m-0" htmlFor="password">
                  Password
                </label>
                <input
                  className="flex w-full rounded-lg text-fg bg-fg/5 border border-fg/10 focus:ring-1 focus:ring-accent-fg focus:border-accent-fg focus:outline-none h-14 placeholder:text-fg-2/50 p-4 text-base font-normal transition-all m-0 box-border"
                  id="password"
                  placeholder="••••••••"
                  required
                  type="password"
                  value={password}
                  onChange={handleChangePassword}
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-xs font-bold text-fg uppercase tracking-wider m-0" htmlFor="confirm-password">
                  Confirm Password
                </label>
                <input
                  className="flex w-full rounded-lg text-fg bg-fg/5 border border-fg/10 focus:ring-1 focus:ring-accent-fg focus:border-accent-fg focus:outline-none h-14 placeholder:text-fg-2/50 p-4 text-base font-normal transition-all m-0 box-border"
                  id="confirm-password"
                  placeholder="••••••••"
                  required
                  type="password"
                  value={confirmPassword}
                  onChange={handleChangeConfirmPassword}
                />
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3 cursor-pointer group" onClick={() => setCheckbox1(!checkbox1)}>
                  <div className={`mt-1 flex-shrink-0 w-5 h-5 rounded border flex items-center justify-center transition-all ${checkbox1 ? 'bg-accent border-accent-fg' : 'bg-fg/5 border-fg/20'}`}>
                    {checkbox1 && <span className="material-symbols-outlined text-[14px] text-on-accent font-bold">check</span>}
                  </div>
                  <div className="text-sm text-fg-2 leading-tight select-none">
                    I agree to Datascient.ai’s{' '}
                    <span 
                      className="text-accent-fg hover:underline cursor-pointer" 
                      onClick={(e) => {
                        e.stopPropagation();
                        setTermsofUse(true);
                      }}
                    >
                      Terms of Use
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-3 cursor-pointer group" onClick={() => setCheckbox2(!checkbox2)}>
                  <div className={`mt-1 flex-shrink-0 w-5 h-5 rounded border flex items-center justify-center transition-all ${checkbox2 ? 'bg-accent border-accent-fg' : 'bg-fg/5 border-fg/20'}`}>
                    {checkbox2 && <span className="material-symbols-outlined text-[14px] text-on-accent font-bold">check</span>}
                  </div>
                  <p className="text-sm text-fg-2 leading-tight select-none m-0">
                    I consent to receive product communication from Datascient.ai
                  </p>
                </div>
              </div>

              <button className="flex w-full cursor-pointer items-center justify-center rounded-lg h-14 bg-accent hover:bg-[#ffe57a] text-on-accent text-base font-extrabold transition-all shadow-lg shadow-accent/5 font-mono uppercase tracking-wider mt-2 border-none" type="submit">
                Create Account
              </button>
            </form>

            <div className="mt-10 text-center w-full">
              <p className="text-fg-2 text-base m-0">
                Already have an account?
                <span className="text-accent-fg font-bold hover:underline ml-1 font-mono cursor-pointer" onClick={() => navigate('/login')}>Login</span>
              </p>
            </div>
          </div>
        ) : (
          <div className="w-full max-w-[440px] flex flex-col z-10 mx-auto text-center">
            <div className="mb-0 self-start">
               <button 
                 onClick={handleBackClick}
                 className="flex items-center gap-2 text-accent-fg hover:underline bg-transparent border-none cursor-pointer font-mono text-sm uppercase tracking-wider p-0 mb-12"
               >
                 <span className="material-symbols-outlined text-lg">arrow_back</span>
                 Back
               </button>
            </div>
            
            <div className="bg-surface p-12 rounded-2xl border border-fg/10 shadow-2xl relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-accent/5 rounded-full -mr-16 -mt-16 blur-2xl"></div>
                <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-8 border border-accent-fg/20">
                   <img src={msglogo} alt="Email" className="w-10 h-10" />
                </div>
                <h2 className="text-3xl font-extrabold text-fg mb-4 font-mono tracking-tight">Check Your Email</h2>
                <p className="text-fg-2 text-lg mb-8 leading-relaxed">
                  We have sent a verification link to your registered mail. Don’t forget to check the spam folder.
                </p>
                <div className="space-y-4">
                   <p className="text-fg-2 text-sm italic">Didn’t receive the email? </p>
                   <button 
                     className="w-full py-4 rounded-lg bg-transparent border border-accent-fg/50 text-accent-fg hover:bg-accent/10 font-bold transition-all cursor-pointer font-mono uppercase tracking-wider"
                     onClick={() => {/* resend logic */}}
                   >
                     Send Again
                   </button>
                </div>
            </div>
          </div>
        )}
      </div>

      <TermsofUseDialog
        open={termsofUse}
        handleClose={() => {
          setTermsofUse(false);
        }}
      />
      
      {loading && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: dsVar('page', 0.7), display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <CircularProgress style={{ color: dsVar('accent-fg') }} thickness={5} />
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default CreateAccount;

